import { useSyncExternalStore } from "react";

/**
 * Boolean "viewport is phone-sized" signal — backed by the same
 * `(max-width: 767px)` cutoff Tailwind uses for `md:`. Used at a small
 * number of structural-branching points (Sidebar drawer vs flex,
 * right-side panels drawer vs sibling). Most responsiveness lives in
 * Tailwind `md:` prefixes; this hook is for the cases where a class
 * flip isn't enough and we need to swap the React tree.
 *
 * `useSyncExternalStore` is the idiomatic React 18+ way to subscribe
 * to an out-of-tree source like `matchMedia` — no setState-in-effect,
 * SSR-safe via the server-snapshot argument.
 */
const MOBILE_QUERY = "(max-width: 767px)";

function getSnapshot(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

function subscribe(callback: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
